import { ecsGetLocationFromIP, isEmptyEcsResponse } from '@/api/geo/geoServiceHttpClient';

/**
 * Get the location from an IP address via geo-service-http (ECS/Fargate).
 *
 * Note: this route does not use an auth token (geo-service-http's get_location_from_ip
 * route takes no context/auth).
 */
export async function getLocationFromIP(ip_address: string) {
    try {
        const response = await ecsGetLocationFromIP(ip_address);
        return isEmptyEcsResponse(response) ? null : response;
    } catch (error) {
        console.error('Failed to fetch location from IP from geo-service-http', error);
        return null;
    }
}
